module.exports = __webpack_public_path__ + "img/8707.63a10ca3.svg";